export default {
  ALIAS: 'ALIAS',
  SET_POSITION: 'SET_POSITION',
  CLEAR_RESPONSE: 'CLEAR_RESPONSE',
  SET_RESPONSES: 'SET_RESPONSES',
  ADD_INCLUDE: 'ADD_INCLUDE',
  REMOVE_INCLUDE: 'REMOVE_INCLUDE',
  STARTED_QUERY: 'STARTED_QUERY',
  CREATE: 'CREATE',
  DESTROY: 'DESTROY',
  SHOW_PROPERTY: 'SHOW_PROPERTY',
  PLACE_ORDER: 'PLACE_ORDER',
  MOVE_TANK: 'MOVE_TANK',
  STOP_TANK: 'STOP_TANK',
  FIRE_TANK: 'FIRE_TANK',
  SET_DEMO_CONFIG: 'SET_DEMO_CONFIG',
  TICK: 'TICK',
  SET_AUTO_SHUTOFF_TIME_IN_MINUTES: 'SET_AUTO_SHUTOFF_TIME_IN_MINUTES',
  SHOW_TRAINING_TIME_WARNING: 'SHOW_TRAINING_TIME_WARNING',
  SET_SUBSCRIPTION: 'SET_SUBSCRIPTION',
  SET_LOGS: 'SET_LOGS',
  SET_CREDENTIALS: 'SET_CREDENTIALS'
}
